import React, { useState, useRef, useEffect } from "react";
import Modal from "./Modal";
import { MODAL_CLOSE } from "src/constants/images";
import Spinner from "components/Loader/Spinner";
import { CLASS_TYPE_ICON } from "src/constants/images";
import * as icon from "services/icon";

const NFT_ITEM = ({
  name,
  accumulatedGbet,
  isGangster,
  _id,
  selected_NFT,
  setSelected_NFT,
  setItemRemaining,
  ItemRemaining,
  setTotalClaimingGbet,
  TotalClaimingGbet,
  setAutoSelectState,
  autoSelect,
  maxItem,
}) => {
  const checkbox = useRef(null);
  const [isChecked, setIsChecked] = useState(selected_NFT.includes(_id));
  useEffect(() => {
    setIsChecked(selected_NFT.includes(_id));
  }, [selected_NFT]);
  return (
    <div
      className={`nft ${isChecked ? "selected" : ""}`}
      onClick={async (e) => {
        console.log(e.target.classList.value);
        console.log("[BEFORE]item Remaining:", ItemRemaining);
        if (e.target.classList.value == "checkbox-mc") {
          if (checkbox.current.checked) {
            await setIsChecked(false);
          } else {
            await setIsChecked(true);
          }
        }
        console.log("[BEFORE]IsChecked:", checkbox.current.checked);
        console.log("[BEFORE]STATE-IsChecked:", isChecked);
        if (ItemRemaining >= 0 && ItemRemaining <= maxItem) {
          if (!isChecked) {
            let list = selected_NFT;
            list.push(_id);
            await setSelected_NFT(list);
            await setItemRemaining(ItemRemaining - 1);
            let newTotal = accumulatedGbet + TotalClaimingGbet;
            await setTotalClaimingGbet(newTotal);
            console.log(`new Total:${newTotal}`);
            checkbox.current.checked = true;
            await setIsChecked(true);
          } else {
            setAutoSelectState(false);
            let list = selected_NFT.filter((data) => data != _id);
            await setSelected_NFT(list);
            await setItemRemaining(ItemRemaining + 1);
            let newTotal = TotalClaimingGbet - accumulatedGbet;
            await setTotalClaimingGbet(newTotal);
            checkbox.current.checked = false;
            await setIsChecked(false);
          }
        } else {
          await setItemRemaining(maxItem);
          await setSelected_NFT([]);
          await setTotalClaimingGbet(0);
          await setIsChecked(false);
        }
        console.log("[AFTER]item Remaining:", ItemRemaining);
      }}
    >
      <div className="g-item">
        <input
          className="checkbox-mc"
          ref={checkbox}
          type="checkbox"
          checked={isChecked}
        />
        <div className="gangsta-type">
          {isGangster == "0x1" ? (
            <img src={CLASS_TYPE_ICON.GANGSTER} />
          ) : (
            <img src={CLASS_TYPE_ICON.DETECTIVE} />
          )}
        </div>
        <p className="nft-name">{name}</p>
      </div>
      <div className="g-item">
        <div className="gbet-accumulated">
          {accumulatedGbet}
          <span>$GBET</span>
        </div>
      </div>
    </div>
  );
};

const MultiClaimModal = ({
  _handleMultiClaimGbet,
  onClose,
  isVisible,
  gangstaCollection,
  selected_NFT,
  setSelected_NFT,
  maxItem,
  setMaxItem,
  filteredCollected,
  ItemRemaining,
  setFilteredCollected,
  autoSelect,
  lazyLoadingGansta,
  setItemRemaining,
  TotalClaimingGbet,
  setTotalClaimingGbet,
  autoSelectState,
  setAutoSelectState,
}) => {
  return (
    <Modal
      isVisible={isVisible}
      overlayClass="overlay"
      className="multi-claim-modal card "
    >
      <div className="header px-4 py-3">
        <div>
          <h4>Multi Claim $GBET</h4>
          <p className="subTitle">Select up to {maxItem} GangstaBet(s).</p>
        </div>
        <div
          onClick={() => onClose()}
          onKeyPress={(e) => e.code == "Enter" && onClose()}
          className="close-modal"
        >
          <img src={MODAL_CLOSE.SOURCE} style={{ filter: "var(--close-white-btn)" }} alt="close" />
        </div>
      </div>
      <div className="search-bar px-4 py-3">
        <input
          className="px-2 py-1"
          placeholder="Filter GangstaBets"
          onChange={(e) => {
            if (e.target.value) {
              let key = e.target.value.toLowerCase();

              let filtered = gangstaCollection.filter((data) => {
                if (data._nftData.token_name.toLowerCase().includes(key)) {
                  return true;
                }
              });
              setFilteredCollected(filtered);
            } else {
              setFilteredCollected(gangstaCollection);
            }
          }}
        />
      </div>
      <div className="mcg-body py-2">
        {filteredCollected?.map((data, index) => (
          <NFT_ITEM
            ischecked={false}
            setSelected_NFT={setSelected_NFT}
            _id={data?._nftData.id}
            setItemRemaining={setItemRemaining}
            selected_NFT={selected_NFT}
            TotalClaimingGbet={TotalClaimingGbet}
            autoSelect={autoSelect}
            maxItem={maxItem}
            autoSelectState={autoSelectState}
            setAutoSelectState={setAutoSelectState}
            name={data?._nftData.token_name}
            setTotalClaimingGbet={setTotalClaimingGbet}
            ItemRemaining={ItemRemaining}
            accumulatedGbet={data?._nftData.accumulatedGbet}
            isGangster={data?._nftData.isGangster}
          />
        ))}
      </div>
      <div className="mcg-info d-flex px-1 py-1">
        <div className="d-flex">
          <div>Total: </div>
          <div className="gbet-value">
            {TotalClaimingGbet} <span>$GBET</span>{" "}
          </div>
        </div>
      </div>
      <div className="mcg-footer px-4 py-3">
        <div className="remaining">{ItemRemaining} remaining</div>
        <div className="d-flex">
          <button
            disabled={lazyLoadingGansta}
            className={`auto-select ${autoSelectState ? "active" : ""}`}
            onClick={() => {
              autoSelect();
            }}
            style={{ border: "1px solid grey" }}
          >
            Auto select
          </button>

          <button
            disabled={lazyLoadingGansta}
            onClick={() => {
              if (selected_NFT.length >= 1) {
                _handleMultiClaimGbet(selected_NFT, TotalClaimingGbet);
              }
            }}
          >
            Claim
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default MultiClaimModal;
